import React, { Component } from "react";

import Video from "../../Components/Video";

class België extends Component {
  render() {
    return (
      <div className="belgië">
        <Video video={"https://www.youtube.com/embed/T3KXGNv2icg"} />
      </div>
    );
  }
}

export default België;
